import { __spreadArray, __assign } from 'tslib';
import React__default from 'react';
import { KpkFilterModifierType } from '@keepeek/commons';
import { FormControl, FormLabel } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import FilterWrapper from '../FilterWrapper/index.js';
import RadioList from '../RadioList/index.js';

var FilterRadio = function (_a) {
    var _b, _c;
    var filter = _a.filter, className = _a.className, expandIcon = _a.expandIcon, _d = _a.maxItemsToShow, maxItemsToShow = _d === void 0 ? 10 : _d, onFilterUpdate = _a.onFilterUpdate, expanded = _a.expanded, setExpanded = _a.setExpanded, sx = _a.sx, KIcon = _a.KIcon;
    var t = useTranslation("refront-components").t;
    var isItemsOverflow = filter.values && filter.values.length > maxItemsToShow;
    var items = isItemsOverflow ? __spreadArray([], filter.values, true).splice(0, maxItemsToShow) : filter.values;
    var currentValue = (_c = (_b = filter.values) === null || _b === void 0 ? void 0 : _b.find(function (f) { return f.selected; })) === null || _c === void 0 ? void 0 : _c.id;
    if (currentValue === undefined) {
        // Need to put empty value here if undefined to keep controlled input
        currentValue = "";
    }
    function handleChange(value) {
        var _a;
        onFilterUpdate(__assign(__assign({}, filter), { modifiers: ((_a = filter.modifiers) === null || _a === void 0 ? void 0 : _a.map(function (m) {
                return __assign(__assign({}, m), { selected: m.type === KpkFilterModifierType.ContainsOne });
            })) || null, values: filter.values.map(function (v) {
                return __assign(__assign({}, v), { selected: "".concat(v.id) === "".concat(value) });
            }) }));
    }
    return (React__default.createElement(FilterWrapper, { className: clsx("FilterRadio", className), filter: filter, expanded: expanded, setExpanded: setExpanded, expandIcon: expandIcon, testId: "FilterRadio", sx: sx, KIcon: KIcon },
        React__default.createElement(FormControl, { component: "fieldset" },
            React__default.createElement(RadioList, { name: filter.id, label: filter.label, value: currentValue, radioListItems: items, handleChange: handleChange }),
            isItemsOverflow && (React__default.createElement(FormLabel, null, t("components.filter-radio.overflow.label", { count: maxItemsToShow }))))));
};

export { FilterRadio as default };
//# sourceMappingURL=index.js.map
